/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import LegacyGrid from './legacy/LegacyGrid';
import { Theme } from '@mui/material';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { categories, Category, CategoryType } from '../common/Categories';
import { getAllModules } from '../common/common';
import DataTable from './DataTable';

interface Props {
  classes?: any
}
const styles = (theme: Theme) => ({
  table: {
    width: '100%',
    padding: '12px'
  }
});
class Role extends React.Component<Props, {}>{
  componentDidMount(){
    getAllModules();
  }
  render() {
      const { classes } = this.props;
    const userrolecategory = categories.find(
      (category: Category) => {
        return category.id === 7 && category.type === CategoryType.UserRole;
      }
    );
    return (
      <LegacyGrid item className={classes.table}>        

        {<DataTable
          selectedCategory={userrolecategory}
        />}
      </LegacyGrid>);
  }
}
export default withStyles(styles)(Role);
